/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'security';

export const certificateManagementModalBreadcrumbTitle = `${prefix}.certificateManagementModalBreadcrumbTitle`;
export const customParamsModalBreadcrumbTitle = `${prefix}.customParamsModalBreadcrumbTitle`;

export const ENGLISH = {
    [certificateManagementModalBreadcrumbTitle]: 'Certificate Management',
    [customParamsModalBreadcrumbTitle]: 'Custom Param',
};
